import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import { AppDispatch } from 'store';
import { setCancellationConfirmationPage } from '../slice';
import { CancellationConfirmationPageType } from '../types';

const fetchCancellationConfirmationPageOperation = () => async (dispatch: AppDispatch) => {
  const data = (await apiRequest(
    endpoints.customerOpPlusV1CancelConfirmationPage,
    {},
    HttpMethods.GET,
    'data',
  )) as CancellationConfirmationPageType;
  if (data) {
    await dispatch(setCancellationConfirmationPage(data));
  }
};

export default fetchCancellationConfirmationPageOperation;
